import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './RightElements.css';
import conti from '../images/conti.gif';
import { PageNavContext } from '../FunctionalPageLoginStart';

const GetProCard = () => {
  const pageNav = useContext(PageNavContext);
  const navigate = useNavigate();

  const handleGoToLessons = () => {
    if (pageNav) {
      pageNav('Invata');
      return;
    }

    navigate('/functionalpagelogin');
  };

  return (
    <div className="rightmenu-card get-pro-card">
      <div className="get-pro">
        <img src={conti} alt="ContaLearn mascot" className="get-pro-mascot" />
        <div className="get-pro-title">Invata fara limite</div>
        <div className="get-pro-desc">
         Tot continutul este acum gratuit pe ContaLearn!
        </div>
        <button type="button" className="go-premium" onClick={handleGoToLessons}>
          <span>Invata gratuit</span>
        </button>
      </div>
    </div>
  );
};

export default GetProCard;
